import React from 'react';
import RibbonMenu from '@/containers/ribbon/RibbonMenu';
import Events from '../hooks/events';

const DatasetValidateDataAction = ({
  category,
  code,
  disabled,
}) => {
  const validate = Events.useValidateDatasetData(category, { code });

  return (
    <RibbonMenu
      name="validate"
      icon="play"
      message="actions.validate"
      className="aridhia-dataset-validate-action"
      onClick={() => validate()}
      disabled={disabled}
    />
  );
};

export default DatasetValidateDataAction;
